export default __webpack_public_path__ + "static/media/profilepic.b2b6d102.jpg";